<style>
</style>
<template>
  <v-row v-if="!hidden">
    <v-col cols="4" class="ma-0 pa-0 pr-1">
      <v-select solo flat persistent-hint :hint="$t('phoneCode')" :label="$t(label)" :items="items" v-model="code"
                required return-object>
        <template slot="selection" slot-scope="data">
          <v-row>
            <v-col cols="2" class="ma-0 pl-1 pa-0">
              <flag :iso="data.item.cca2" :squared="false" :title="getLocalizedCommonName(data.item)"/>
            </v-col>
            <v-col cols="10" class="ma-0 pa-0">
              <div class="text-right">
                {{ getLocalizedCommonName(data.item) }}
              </div>
            </v-col>
          </v-row>
        </template>
        <template slot="item" slot-scope="data">
          <v-row>
            <v-col cols="2" class="ma-0 pa-0">
              <flag :iso="data.item.cca2" :squared="false" :title="getLocalizedCommonName(data.item)"/>
            </v-col>
            <v-col cols="10" class="ma-0 pa-0">
              <div>
                {{ getLocalizedCommonName(data.item) }}
              </div>
            </v-col>
          </v-row>
        </template>
      </v-select>
    </v-col>
    <v-col cols="8" class="ma-0 pa-0 pl-1">
      <v-text-field solo flat persistent-hint
                    :hint="hintValue"
                    :label="$t(label)"
                    :value="inputValue"
                    @input="getInput"
                    :required="required"
                    :clearable="clearable"
                    :counter="counter ? counter : false"
                    :mask="mask"
                    :rules="rules"
                    :disabled="disabled"
                    :error="error"
                    :error-messages="$t(errorMessage)"
      ></v-text-field>
    </v-col>
  </v-row>
</template>
<script>
import CountryMixin from '../mixins/country-mixin.js'
import TransformMixin from '../mixins/transform-mixin.js'
// import Flag from '@/components/flag.vue'

export default {
  name: 'setting-phone',
  props: {
    name: {
      type: String,
      default: 'title'
    },
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    hint: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    hidden: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: null
    }
  },
  // components: {
  //   Flag
  // },
  mixins: [CountryMixin, TransformMixin],
  data() {
    return {
      code: null,
      rules: [
        (v) => !this.required || this.rule.required(v),
        (v) => (!v || !this.counter || v.length === this.counter) || this.transform(this.hintValue),
        () => !this.error || this.transform(this.hintValue)
      ],
      rule: {
        required: (v) => !!v || this.transform(this.hintValue)
      }
    }
  },
  computed: {
    items: {
      get() {
        return this.filteredCountries
      }
    },
    error: {
      get() {
        return this.errorMessage !== null
      }
    },
    labelValue: {
      get() {
        return this.label ? this.label : this.name
      }
    },
    inputValue: {
      get() {
        const v = this.value ? this.value : this.defaultValue
        return v !== null ? v.substring(v.length - this.counter) : ''
      }
    },
    mask: {
      get() {
        return this.getMask(this.code)
      }
    },
    counter: {
      get() {
        return (this.mask.match(/#/g) || []).length
      }
    },
    callingCode: {
      get() {
        return this.getCallingCode(this.code)
      }
    },
    hintValue: {
      get() {
        return this.transform('phone') + (this.required ? ' *' : '')
      }
    },
  },
  methods: {
    getInput(value) {
      if (value && value.length === this.counter) {
        this.$emit('input', '+' + this.callingCode + value)
      }
    }
  },
  created() {
    this.code = this.items.find(c => c.cca2 === 'CZ')
  },
  watch: {
    callingCode(value) {
      this.getInput(value)
      // if (this.inputValue && this.inputValue.length === this.counter) {
      //   this.$emit('input', '+' + this.callingCode + this.inputValue)
      // }
    }
  }
}
</script>
